import "./Home.css";
import React from "react";
import Propulator from "higher-order/Propulator";
import MobxView from "higher-order/MobxView";
import { URLS } from "util/constants";
import HomeStore, { MS_AT_WORK_VIDEO_KEY, ANDERSEN_TAX_VIDEO_KEY } from "../models/HomeStore";
import { observer } from "mobx-react";
import MarketingHero from "../components/MarketingHero";
import MarketingPageContent from "../components/MarketingPageContent";
import { renderMSAtWorkVideoCard, renderMarketingTestimonial } from "../components/MarketingVideoHelpers";
import LogoGarden from "../components/LogoGarden";
import ContentItem from "shared/components/cms/ContentItem";
import Mouseflow from "shared/components/Mouseflow";

const LEGAL_TEXT_KEYS = [
    "legalText1",
    "legalText2"
];

@observer
class Home extends React.Component {
    componentDidMount() {
        Mouseflow();
    }

    render() {

        return (
            <MarketingPageContent enableSubfooter={true} legalTextKeys={LEGAL_TEXT_KEYS}>
                <img alt="background" src={require("../assets/redesign2020/background-triangle.svg")} className="marketing-home-background-image" />
                <div className="marketing-home">
                    <MarketingHero
                        desktopImage={require("../assets/redesign2020/home/desktop-hero.png")}
                        tabletImage={require("../assets/redesign2020/home/tablet-hero.png")}
                        mobileImage={require("../assets/redesign2020/home/mobile-hero.png")}
                        containsChevron={true}
                        buttonHref={URLS.MARKETING.PRODUCTS}
                        buttonText={"Discover How"}
                    >
                        <span>Together, we can</span>
                        <span>deliver financial</span>
                        <span>wellness benefits</span>
                        <span className="highlighted">that work</span>.
                    </MarketingHero>
                    <div className="marketing-body">
                        <div className="solutions">
                            <div className={"solutions-body"}>
                                <ContentItem tag="h2" contentKey="solutionsHeader" className="solutions-header" />
                                <ContentItem tag="p" contentKey="solutionsBodyText1" className="solutions-body-text" />
                                <ContentItem tag="p" contentKey="solutionsBodyText2" className="solutions-body-text" />
                                <a href={this.props.session.requestInfoUrl} className="solutions-body-link" target="_blank">
                                    <ContentItem tag="span" contentKey="solutionsCTA" />
                                </a>
                            </div>
                            <img className="solutions-image" alt="Gradifi FinCore, College SaveUp and Student Loan PayDown" src={require("../assets/redesign2020/home/gradifi-products.png")} />
                        </div>
                        {/* GR-8033 MSAW video temporarily suspended */}
                        {false && renderMSAtWorkVideoCard(this.props.videoModals[MS_AT_WORK_VIDEO_KEY])}
                        <div className="logo-garden-wrapper">
                            <LogoGarden />
                        </div>
                        <div className="impact-card-wrapper">
                            <div className="impact-card">
                                <img alt={"Gradifi impact on student debt"} className="impact-image" src={require("../assets/redesign2020/home/impact-graph.png")} />
                                <div className="impact-body">
                                    <img className="chevron" alt="chevron" src={require("../assets/redesign2020/chevron-darker.svg")} />
                                    <h2 className="impact-header">Build a happier, healthier, <span className="highlighted">more productive workforce</span>.</h2>
                                    <ContentItem tag="p" contentKey="impactBodyText1" className="impact-body-text legal-text-1" />
                                    <h3 className="impact-subheader">Give employees access to benefits that can help them <span className="highlighted">take control of their financial well-being</span>.</h3>
                                    <ContentItem tag="p" contentKey="impactBodyText2" className="impact-body-text" />
                                </div>
                                <a href={URLS.MARKETING.PAYDOWN} className="button">
                                    <ContentItem tag="span" contentKey="impactCTA" />
                                </a>
                            </div>
                        </div>
                        <div className="talent-card-wrapper">
                            <img className="talent-card-background-desktop" alt="background" src={require("../assets/redesign2020/home/background-triangle-tablet.png")} />
                            <div className="talent-card">
                                <div className="talent-card-image-wrapper">
                                    <img className="talent-card-background-tablet" alt="background" src={require("../assets/redesign2020/home/background-triangle-tablet.png")} />
                                    <img alt={"Bring in top-tier talent"} className="talent-card-image" src={require("../assets/redesign2020/home/culture-image.png")} />
                                </div>
                                <div className="talent-card-body">
                                    <img alt="chevron" className="chevron" src={require("../assets/redesign2020/chevron.svg")} />
                                    <h2 className="talent-card-header">
                                        <span className="sentence">Bring in top-tier talent.</span>
                                        <span className="highlighted">Build a strong culture</span>.
                                        <span className="sentence"> Improve employee engagement.</span>
                                    </h2>
                                    <ContentItem tag="p" contentKey="talentCardText" className="talent-card-text" />
                                    <a href={URLS.MARKETING.CONTACT} className="talent-card-link">
                                        <ContentItem sharedKey="home" tag="span" contentKey="talentCardCTA" />
                                    </a>
                                </div>
                            </div>
                        </div>
                        {renderMarketingTestimonial(this.props.videoModals[ANDERSEN_TAX_VIDEO_KEY])}
                    </div>
                </div>
            </MarketingPageContent>
        );
    }
}
const propulatedView = Propulator(Home, {
    homeStore: [
        "enabledOffers",
        "videoModals"
    ],
    sessionStore: [
        "featureToggles",
        "externalUrls",
        "session"
    ]
});
export default MobxView(propulatedView, {
    HomeStore
});
